<div class="data-table">
  <div class="data-table__container">
    <table mat-table [dataSource]="dataSource()" matSort class="data-table__table">
      @for (column of visibleColumns(); track column.key) {
      <ng-container [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.sortable !== false ? column.key : null"
          [attr.aria-label]="column.ariaLabel" [matTooltip]="column.tooltip || ''"
          [style.width]="column.width || 'auto'" [class]="'data-table__header-cell ' + getColumnClass(column)">
          @if (!column.hideLabel) {
            {{ column.label }}
          }
          @if (column.tooltip) {
            <mat-icon class="data-table__header-tooltip-icon" aria-label="{{ column.tooltip }}">info</mat-icon>
          }
        </th>

        <td mat-cell *matCellDef="let row" class="data-table__row"
          [ngClass]="getRowClasses(row)" (click)="onRowClick($event, row)">
          <div class="data-table__cell-box">
            @if (getColumnTemplate(column.customTemplate ?? column.key); as tpl) {
            <ng-container [ngTemplateOutlet]="tpl!"
              [ngTemplateOutletContext]="{ $implicit: row, row: row, column: column }" />
            } @else {
              <ng-template #cellContent>
                @let cellValue = getCellValue(row, column.key);
                @switch (column.format) {
                  @case ('currency') {
                  <span class="data-table__cell-default">
                    {{ cellValue | currency : (column.formatOptions?.currency || 'MXN') : 'symbol-narrow' :
                    (column.formatOptions?.digits || '1.2-2') }}
                  </span>
                  }
                  @case ('number') {
                  <span>{{ cellValue | number: column.formatOptions?.digits || '1.0-2' }}</span>
                  }
                  @case ('percent') {
                  <span>{{ (cellValue || 0) | number: column.formatOptions?.digits || '1.0-0' }}%</span>
                  }
                  @case ('date') {
                  <span> {{ cellValue | date:(column.formatOptions?.format || 'dd/MM/yyyy') }}</span>
                  }
                  @case ('chip') {
                  <mat-chip [class]="getChipClass(cellValue, column)" selected>{{ getChipDisplayValue(cellValue, column)
                    }}</mat-chip>
                  }
                  @case ('icon') {
                  <mat-icon [class]="getIconClass(cellValue, column)" [matTooltip]="getIconTooltip(row, column)">
                    {{ getIconName(cellValue, column) }}
                  </mat-icon>
                  }
                  @case ('boolean') {
                  @switch (getBooleanDisplayType(column)) {
                    @case ('icon') {
                    <mat-icon [color]="getBooleanClass(cellValue, column)" [matTooltip]="getBooleanText(cellValue, column)">{{ getBooleanIcon(cellValue, column) }}</mat-icon>
                    }
                    @case ('text') {
                    <span [ngClass]="getBooleanClass(cellValue, column)">{{ getBooleanText(cellValue, column) }}</span>
                    }
                    @case ('chip') {
                    <mat-chip [class]="getBooleanClass(cellValue, column)" selected>{{ getBooleanText(cellValue, column)
                      }}</mat-chip>
                    }
                  }
                }
                @case ('custom') {
                  <span>{{ formatCustomValue(cellValue, row, column) }}</span>
                }
                @default {
                  <span class="data-table__cell-default" [matTooltip]="(column.showTooltip !== false) ? cellValue : ''">{{ cellValue }}</span>
                }
                }
              </ng-template>

              @if (column.linkTemplate) {
                <a class="data-table__link" [href]="generateLink(column.linkTemplate, row)" target="_blank"
                  rel="noopener noreferrer" (click)="$event.stopPropagation()">
                  <ng-container [ngTemplateOutlet]="cellContent" />
                </a>
              } @else {
                <ng-container [ngTemplateOutlet]="cellContent" />
              }
            }
          </div>
        </td>

        <td mat-footer-cell *matFooterCellDef [class]="'data-table__footer-cell ' + getColumnClass(column)">
          @let footerKey = column.customTemplate ?? column.key;
          @if (getFooterTemplate(footerKey)) {
            <ng-container [ngTemplateOutlet]="getFooterTemplate(footerKey)!"
              [ngTemplateOutletContext]="{ $implicit: totalsSummary(), column: column }"></ng-container>
          } @else {
            <span>{{ getTotalValue(column.key) }}</span>
          }
        </td>
      </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true" class="data-table__header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()" class="data-table__row" [class.data-table__row--selected]="row === selectedRow()"></tr>
      <tr mat-footer-row id="step-total" *matFooterRowDef="displayedColumns(); sticky: true"
        [hidden]="!showTotalsRow() || dataSource().filteredData.length === 0" class="data-table__footer-row"></tr>

      <tr class="data-table__no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns().length">
          <ng-content select="[noDataContent]"></ng-content>
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator id="step-paginator" class="data-table__paginator" [pageSizeOptions]="pageSizeOptions()"
    [length]="length()" [pageSize]="initialPageSize()" showFirstLastButtons></mat-paginator>

  <ng-template #defaultCellTemplate let-row let-column="column">
    {{ getCellValue(row, column.key) }}
  </ng-template>

  <ng-template #defaultFooterTemplate let-totals let-column="column">
    {{ getTotalValue(column.key) }}
  </ng-template>

  <ng-content></ng-content>
</div>
